import React, { PropsWithChildren } from 'react';
import PropTypes from 'prop-types'

const NonAuthLayout = (props : PropsWithChildren) => {
  return (
    <React.Fragment>{props.children}</React.Fragment>
  );
}

NonAuthLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object
}

export default NonAuthLayout
